<div class="d-flex flex-column flex-root app-root" id="au_app_root">
    <div class="app-page flex-column flex-column-fluid" id="au_app_page">
      <app-header></app-header>
      <div class="app-wrapper flex-column flex-row-fluid" id="au_app_wrapper">
        <div class="app-main flex-column flex-row-fluid" id="au_app_main">
          <div class="d-flex flex-column flex-column-fluid">
            <div id="au_app_content" class="app-content flex-column-fluid pt-2 pb-0">
              <div id="au_app_content_container" class="app-container container-xxl px-0">
                  <div class="card">
                    <div class="card-header">
                      <div class="card-title">
                        <h4>By deactivating the site, the entire app will become inaccessible to all users, except the admin</h4>
                      </div>
                      <div class="card-toolbar"> <span class="btn btn-sm btn-primary my-1"> Deactivate Site</span> </div>
                    </div>
                  </div>
                    <div class="dashboard-items mt-3 d-flex bg-white bdr-5">					  
                  <div class="col-xl-3 ps-4 py-4">
                    <div class="card h-md-100 bg-light-blue" dir="ltr">
                      <div (click)="viewCompany()" class="card-body d-flex flex-column flex-center cursor-pointer">
                        <div class="mb-2">
                          <div [attr.title]="'View all companies'" class="py-10 text-center"><img src="assets/media/misc/company-lg.png" class="w-100px" alt="" draggable="false"/></div>
                          <h1 [attr.title]="'View all companies'" class="fw-semibold text-gray-800 text-center lh-lg"> Company</h1>
                          <h4 class="fw-normal text-center"></h4>
                        </div>
                        <div class="text-center mb-1"> <a routerLink="/system-admin-dashboard/company/add-company" draggable="false" class="btn btn-sm btn-secondary me-2">Add New Company </a> <a [attr.title]="'View all companies'" draggable="false" class="btn btn-sm btn-teritary" routerLink="/system-admin-dashboard/company"> <i class="bi bi-arrow-up-right"></i></a> </div>
                      </div>
                    </div>
                  </div>
                    <div class="col-xl-3 ps-4 py-4">
                    <div class="card h-md-100 bg-light-blue" dir="ltr">
                      <div (click)="viewBranch()" class="card-body d-flex flex-column flex-center cursor-pointer">
                        <div class="mb-2">
                          <div [attr.title]="'View all branches'" class="py-10 text-center"><img src="assets/media/misc/branch-lg.png" class="w-100px" alt="" draggable="false"/></div>
                          <h1 [attr.title]="'View all branches'" class="fw-semibold text-gray-800 text-center lh-lg"> Branch</h1>
                          <h4 class="fw-normal text-center"></h4>
                        </div>
                        <div class="text-center mb-1"> <a class="btn btn-sm btn-secondary me-2" draggable="false" routerLink="/system-admin-dashboard/branch/add-branch"> Add New Branch </a> <a [attr.title]="'View all branches'" draggable="false" class="btn btn-sm btn-teritary" routerLink="/system-admin-dashboard/branch"> <i class="bi bi-arrow-up-right"></i></a> </div>
                      </div>
                    </div>
                  </div>
                    <div class="col-xl-3 ps-4 py-4">
                    <div class="card h-md-100 bg-light-blue" dir="ltr">
                      <div (click)="viewUsers()" class="card-body d-flex flex-column flex-center cursor-pointer">
                        <div class="mb-2">
                          <div [attr.title]="'View all users'" class="py-10 text-center"><img src="assets/media/misc/user-lg.png" class="w-100px" alt="" draggable="false"/></div>
                            <h1 [attr.title]="'View all users'" class="fw-semibold text-gray-800 text-center lh-lg"> Users</h1>
                          <h4 class="fw-normal text-center"></h4>
                        </div>
                        <div class="text-center mb-1"> <a class="btn btn-sm btn-secondary me-2" draggable="false" routerLink="/system-admin-dashboard/user/add-user"> Add New User </a> <a [attr.title]="'View all users'" draggable="false" class="btn btn-sm btn-teritary" routerLink="/system-admin-dashboard/user"> <i class="bi bi-arrow-up-right"></i></a> </div>
                      </div>
                    </div>
                  </div>
                    <div class="col-xl-3 px-4 py-4">
                    <div class="card h-md-100 bg-light-blue" dir="ltr">
                      <div (click)="viewSystemAdmin()" class="card-body d-flex flex-column flex-center cursor-pointer">
                        <div class="mb-2">
                          <div [attr.title]="'View System settings'" class="py-10 text-center"><img src="assets/media/misc/system-settings-lg.png" class="w-100px" alt="" draggable="false"/></div>
                          <h1 [attr.title]="'View System settings'" class="fw-semibold text-gray-800 text-center lh-lg"> System Settings</h1>
                          <h4 class="fw-normal text-center"></h4>
                        </div>
                        <div class="text-center mb-1"><a [attr.title]="'View System settings'" draggable="false" class="btn btn-sm btn-teritary" routerLink="/system-admin-dashboard/system-settings"> <i class="bi bi-arrow-up-right"></i></a> </div>
                      </div>
                    </div>
                  </div>
                    </div>
              </div>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>